<template>
    <div class="message-box" v-show="messageBoxShow">
        <section class="message-box-wrap">
            <h2>提示</h2>
            <p>{{message}}</p>
            <span class="ensure-btn" @click.stop.prevent="handleEnsure">{{btnText?btnText:'确定'}}</span>
        </section>
    </div>
</template>

<script>
    export default{
        name:'messageBox',
        data(){
            return {
                messageBoxShow:false
            }
        },
        props:{
            message:String,
            btnText:String,
            callBack:Function
        },
        mounted(){

        },
        methods:{
            handleEnsure(){
                this.messageBoxShow = false;
                if(this.callBack!=null){
                    this.callBack()
                }
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../resource/css/color";

    .message-box{
        font-size: .28rem;
        position: fixed;
        top:0;
        left: 0;
        right:0;
        bottom: 0;
        z-index: 9999999;
        background: rgba(0,0,0,.6);
    }
    .message-box-wrap{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 5.3rem;
        padding: .4rem .23rem;
        background: #ffffff;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border-radius: .2rem;
        h2{
            font-size: .28rem;
            text-align: center;
            padding-bottom: .4rem;
            border-bottom: 1px solid #e3e3e3;
        }
        p{
            text-align: center;
            line-height: .54rem;
            margin: .4rem 0;
            font-size: .24rem;
        }
        span{
            width: 3.5rem;
            display: block;
            color: #ffffff;
            background: $mainColor;
            line-height: .65rem;
            margin: 0 auto;
            text-align: center;
            font-size: .28rem;
            border-radius: .4rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/messageBox/messageBox.vue